import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { MarkerDimension } from '../case/case.state'
import { PlotAxis } from './plot-data.state'

export const plotDataActions = createActionGroup({
    source: 'Case',
    events: {
        'Load Data For Axis': props<{
            marker: MarkerDimension | null
            axis: PlotAxis
        }>(),
        'Load Data Both Axes': props<{
            markerXAxis: MarkerDimension
            markerYAxis: MarkerDimension
        }>(),
        'Plot Drawn': emptyProps(),
        'Set Point Size': props<{ size: number }>(),
        'Set Point Opacity': props<{ opacity: number }>(),
        'Set Lasso Type': props<{ lassoType: string }>(),
    },
})
